import { render } from "./Inteqt.vue?vue&type=template&id=72032aca&scoped=true"
import script from "./Inteqt.vue?vue&type=script&lang=js"
export * from "./Inteqt.vue?vue&type=script&lang=js"

import "./Inteqt.vue?vue&type=style&index=0&id=72032aca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72032aca"]])

export default __exports__